var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaxForm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "-7.98 0 48.891 48.891",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tax_returns",
    "data-name": "tax returns",
    transform: "translate(-234.036 -34.49)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M266.464,34.99H234.536V74.9l7.982,7.982h23.946V34.99Z",
    fill: "#ffe97a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M246.509,34.99H234.536V74.9l7.982,7.982h23.946V34.99H254.491m-3.492,0h-1M238.527,62.926h15.964m-15.964-3.991h23.946m-23.946-3.991h23.946m0,23.946h-7.982M234.536,74.9h7.982v7.982m13.968-39.909,5.987,6.391m-5.987-.4,5.987-5.986m-8.98,4.988h-5.986m0,1,2.993-5.986,2.993,5.986m-14.966-5.986h5.987m-2.994,0v5.986",
    fill: "none",
    stroke: "#882a02",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxForm);
export default __webpack_public_path__ + "static/media/taxForm.1420e6429c77a6e9cb329363a9d71827.svg";
export { ForwardRef as ReactComponent };